/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IndividualBusinessman } from './IndividualBusinessman'
import {
  instanceOfIndividualBusinessman,
  IndividualBusinessmanFromJSON,
  IndividualBusinessmanFromJSONTyped,
  IndividualBusinessmanToJSON,
} from './IndividualBusinessman'
import type { IndividualEntity } from './IndividualEntity'
import {
  instanceOfIndividualEntity,
  IndividualEntityFromJSON,
  IndividualEntityFromJSONTyped,
  IndividualEntityToJSON,
} from './IndividualEntity'
import type { LegalEntity } from './LegalEntity'
import {
  instanceOfLegalEntity,
  LegalEntityFromJSON,
  LegalEntityFromJSONTyped,
  LegalEntityToJSON,
} from './LegalEntity'

/**
 * @type ApplicationFirstStageDataCustomerOrganizationData
 *
 * @export
 */
export type ApplicationFirstStageDataCustomerOrganizationData =
  | IndividualBusinessman
  | IndividualEntity
  | LegalEntity

export function ApplicationFirstStageDataCustomerOrganizationDataFromJSON(
  json: any
): ApplicationFirstStageDataCustomerOrganizationData {
  return ApplicationFirstStageDataCustomerOrganizationDataFromJSONTyped(
    json,
    false
  )
}

export function ApplicationFirstStageDataCustomerOrganizationDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationFirstStageDataCustomerOrganizationData {
  if (json == null) {
    return json
  }
  if (instanceOfIndividualBusinessman(json)) {
    return IndividualBusinessmanFromJSONTyped(json, true)
  }
  if (instanceOfIndividualEntity(json)) {
    return IndividualEntityFromJSONTyped(json, true)
  }
  if (instanceOfLegalEntity(json)) {
    return LegalEntityFromJSONTyped(json, true)
  }

  return {} as any
}

export function ApplicationFirstStageDataCustomerOrganizationDataToJSON(
  value?: ApplicationFirstStageDataCustomerOrganizationData | null
): any {
  if (value == null) {
    return value
  }

  if (instanceOfIndividualBusinessman(value)) {
    return IndividualBusinessmanToJSON(value as IndividualBusinessman)
  }
  if (instanceOfIndividualEntity(value)) {
    return IndividualEntityToJSON(value as IndividualEntity)
  }
  if (instanceOfLegalEntity(value)) {
    return LegalEntityToJSON(value as LegalEntity)
  }

  return {}
}
